var rain_interval = null;
$(function(){

    var $faq = $('dl.collapsible');
    if ($faq.hasClass('collapsed')) 
        $faq.find('dd').hide();//hide all answers by default
    $faq.find('dt').each(function(){
        $this = $(this);
        $this.html('<a href="#">' + $this.text() + '</a>');
    });
    $faq.find('dt a').click(function(){
        $this = $(this);
        //handle questions with multiple answers
        $cur = $this.parent().next();
        while ($cur.is('dd')) {
            $cur.toggle();
            $cur = $cur.next();
        }
        return false;
    });
    
    var calc_html = '<h4>How much water is coming off your roof?</h4><h3 id="calculate-it">Calculate It!</h3><small>(Calculator is based on 30 year historical weather data  for Raleigh, NC)</small><br />'
    calc_html += '<label>Your Roof Square Footage: <input class="form-text" id="sqft" type="text" size="3"/></label>'
    calc_html += '<h5>Estimated Rainfall per year: <span id="answer"></span></h5>';
    $('#calculator').html(calc_html);
    $('#sqft').bind('keyup change', function(){
        var $sqft = $(this);
        var sqft = parseFloat($sqft.val());
        if (sqft && sqft > 0) {
            $('#answer').text((sqft * 47.59 * 0.6 * 0.8).toFixed(2) + ' gallons')
        }
        else {
            $('#answer').text('');
        }
    });
    if ($('#rws-rain').length == 1) {
        $('#hd h1 a').hover(function(){
            rain_interval = window.setInterval(function(){
                var l = Math.floor(Math.random() * 500)
                var t = Math.floor(Math.random() * 10)
                $('#rws-rain').animate({
                    'backgroundPosition': l + 'px ' + t + 'px'
                }, 0);
            }, 500);
        }, function(){
            window.clearInterval(rain_interval);
            $('#rws-rain').animate({
                'backgroundPosition': '0px 0px'
            }, 0);
        });
        
    }
    
    $('#cartform').submit(function(){
		var $phone = $('input[name="attributes[phone]"]');
        if( $phone.val().length < 7) {
            alert('Please enter a valid phone number');
            $('#phone').addClass('error');
            return false;
        }
        return true;
        
    });//cartform submit
  
  	// survey logic
    $(function(){
      $survey_toggler = $('.toggle-survey');
      $survey_content = $('.survey-content');
      function toggleSurvey(e) {
        if ( $survey_content.is(':visible') ) {
          $survey_content.hide();
          $survey_toggler.text('Show Survey');
        }
        else {
          $survey_content.show();
          $survey_toggler.text('Hide Survey')
        }
        e.preventDefault();
      }
      $survey_toggler.click(toggleSurvey)
  	});
  
  // Fancybox
  $('.fancybox-button-custom').fancybox({
		maxWidth	: 800,
		maxHeight	: 600,
		fitToView	: false,
		width		: '70%',
		height		: '70%',
		autoSize	: false,
		closeClick	: false,
		openEffect	: 'none',
		closeEffect	: 'none'
	});
});
